import apiClient from './apiClient'

export const sendCustomerContact = async (target, subject, message) => {
  const { data } = await apiClient.post('/auth/admin/contact-customer/', {
    ...target,
    subject,
    message,
  })
  return data
}

export const getContactOrders = async (userId, email) => {
  const orders = []
  let page = 1
  let hasNext = true

  while (hasNext) {
    const params = { page, page_size: 100 }
    if (userId) params.customer_id = userId
    else params.search = email

    const { data } = await apiClient.get('/orders/', { params })
    const rows = Array.isArray(data) ? data : (data.results || [])
    orders.push(...rows.filter((order) => userId
      ? String(order.user) === String(userId)
      : (order.customer_email || '').toLowerCase() === email.toLowerCase()))
    hasNext = !Array.isArray(data) && !!data.next
    page += 1
  }

  return orders
}
